import type { IGatewayResponse } from '@/Module/Core/Model/ApiModel';
import { CookieService } from '@/Module/Core/Service';
import type { IDispatch } from '@/Module/Store/Model';
import type { ISubscriptionsV2User } from '@/Module/Subscription/Model/DataModel';
import { getSubscriptionsV2UserAction } from '@/Module/Subscription/Store/Action';

export const checkActivePlan = async (dispatch: IDispatch) => {
  const accessToken = CookieService.getAccessToken();
  if (!accessToken) return false;
  const list: IGatewayResponse<ISubscriptionsV2User[]> = await dispatch(getSubscriptionsV2UserAction(accessToken)).unwrap();
  return !!list.data.find(p => new Date(p.endDate) >= new Date());
};
